module.exports = __webpack_public_path__ + "img/discover_on.a770cc23.png";